<template>
    <el-table ref="elTable" border :data="tableData" style="width: 100%" max-height="500px">
      <!-- 物流单号 -->
      <el-table-column align="center" prop="trackingId" :label="this.$t('OrdinaryOrderMix.LogiTab.Tracking')" min-width="125"></el-table-column>
      <!-- 包裹号 -->
      <el-table-column align="center" prop="articleId" :label="this.$t('OrdinaryOrderMix.LogiTab.Parcel')" min-width="125"></el-table-column>
      <!-- 状态 -->
      <el-table-column align="center" prop="lastStatus" :label="this.$t('OrdinaryOrderMix.LogiTab.Status')" min-width="141">
        <template slot-scope="{ row }">{{ getLastStatusText(row.lastStatus) }}</template>
      </el-table-column>
      <!-- 物流公司 -->
      <el-table-column align="center" prop="logisticsBusinessName" :label="this.$t('OrdinaryOrderMix.LogiTab.Company')" min-width="125"></el-table-column>
      <!-- 物流业务类型 -->
      <el-table-column align="center" prop="logisticsCompany" :label="this.$t('OrdinaryOrderMix.LogiTab.Type')" min-width="125"></el-table-column>
      <!-- 运费 -->
      <!-- <el-table-column align="center" prop="provider" :label="this.$t('OrdinaryOrderMix.LogiTab.Freight')" min-width="125"></el-table-column> -->
      <!-- 包裹号获取时间 -->
      <el-table-column align="center" prop="logisticsCreateTime" :label="this.$t('OrdinaryOrderMix.LogiTab.Time')" min-width="125">
        <template slot-scope="scope">{{ scope.row.logisticsCreateTime | timeFilters(scope.row.logisticsCreateTime) }}</template>
      </el-table-column>
      <!-- 轨迹最新更新时间 -->
      <el-table-column align="center" prop="lastLogisDate" :label="$t('OrdinaryOrderMix.LogiTab.updateTime')" min-width="150">
        <template slot-scope="{ row }">{{ row.lastLogisDate | timeFilters(row.lastLogisDate) }}</template>
      </el-table-column>
      <!-- 最新轨迹 -->
      <el-table-column align="center" prop="lastLocation" :label="$t('OrdinaryOrderMix.LogiTab.trackingStatus')" min-width="180" show-overflow-tooltip />
    </el-table>
  </template>
  <script>
  import { orderApi } from '@/api';

  export default {
    name: 'ParcelNumber',
    components: {},
    props: {
      maxHeight: {
        type: [Number, String],
        default: 500,
      },
    },
    data() {
      return {
        tableData: [],
        // 已签收
        isSignedList: [
          'Delivered',
          'Delivered Short',
          'Delivered - Accepted By: ATL',
          "We've delivered your shipment",
          'Delivered - Left in a safe place',
          'Your parcel has been delivered and a signature obtained.',
          'Your parcel has been delivered according to delivery instructions.',
          'Your parcel has been delivered according to your delivery instructions.',
        ],
        // 无记录
        noRecordList: [
          'PMIN',
          'Assigned',
          'SubmitOrder',
          'Information Received',
          'Your shipment data is lodged',
          'Shipping information received by Australia Post',
          'Your shipping information has been submitted to Aramex.',
        ],
      };
    },
    computed: {
      innerOrderNo() {
        return this.$route.query.code || null;
      },
    },
    created() {
      this.getDataOfSearch();
    },
    methods: {
      async getDataOfSearch() {
        if (!this.innerOrderNo) {
          this.tableData = [];
          return;
        }

        try {
          const res = await orderApi.getInternalTrackInfo({ innerOrderNo: this.innerOrderNo });
          if (Array.isArray(res)) {
            this.tableData = res;
          } else {
            this.tableData = [];
          }
        } catch (error) {
          this.tableData = [];
        }
      },
      doLayout() {
        this.$refs.elTable && this.$refs.elTable.doLayout();
      },
      getLastStatusText(lastStatus) {
        const status = this.normalizeLastStatus(lastStatus);
        if (this.isStatusInList(status, this.isSignedList)) return this.$t('OrdinaryOrderMix.LogiTab.Delivered');
        if (this.isStatusInList(status, this.noRecordList)) return this.$t('OrdinaryOrderMix.LogiTab.NoRecord');
        return this.$t('OrdinaryOrderMix.LogiTab.InTransit');
      },
      normalizeLastStatus(lastStatus) {
        return String(lastStatus || '').trim().toLowerCase();
      },
      isStatusInList(status, list) {
        return list.some(item => this.normalizeLastStatus(item) === status);
      },
    },
  };
  </script>
